import { IntlShape } from 'react-intl';

/** A stored day (`YYYY-MM-DD`, UTC) as "Fri 6 Nov 2026". The UTC zone keeps the day for everyone. */
export function formatReleaseDay(intl: IntlShape, day: string, withYear: boolean = true): string {
  return intl.formatDate(`${day}T00:00:00Z`, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: withYear ? 'numeric' : undefined,
    timeZone: 'UTC',
  });
}
